/**
 * Brand Sync — keeps cart.attributes.brand in sync with the active brand.
 *
 * Priority:
 * 1. ?brand= URL parameter (if present, overrides everything, then cleans URL)
 * 2. data-brand from <body> (set by Liquid domain detection)
 *
 * All brand domains share one cart, so a window on another brand can
 * overwrite the attribute at any time. Every page load verifies against
 * /cart.js (POSTs only on mismatch), and the check re-runs when the window
 * regains focus/visibility so the last brand the visitor is on wins —
 * including when they proceed to checkout from an already-loaded page.
 */
(async function brandSync() {
  var validBrands = ['hall', 'walt', 'baca', 'michelfoch'];
  var storageKey = 'brand-synced';

  // 1. Check for ?brand= query parameter override
  var params = new URLSearchParams(window.location.search);
  var paramBrand = params.get('brand');

  if (paramBrand && validBrands.indexOf(paramBrand) !== -1) {
    // Clean the URL immediately (remove ?brand= so it doesn't persist)
    params.delete('brand');
    var cleanUrl = window.location.pathname;
    if (params.toString()) cleanUrl += '?' + params.toString();
    cleanUrl += window.location.hash;
    history.replaceState(null, '', cleanUrl);

    // Force sync this brand to cart, then reload so Liquid picks it up
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { brand: paramBrand } })
      });
      sessionStorage.setItem(storageKey, paramBrand);
      // Reload so Liquid re-renders with the cart attribute fallback
      window.location.reload();
    } catch (e) {
      // Fall through to normal sync
    }
    return;
  }

  // 2. Normal sync: make the shared cart's brand match this window's brand
  var brand = document.body.getAttribute('data-brand');
  if (!brand) return;

  var syncing = false;
  var lastRun = 0;

  async function syncBrand() {
    if (syncing) return;
    if (Date.now() - lastRun < 1000) return;
    lastRun = Date.now();
    syncing = true;

    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await res.json();
      var cartBrand = cart.attributes && cart.attributes.brand;

      if (cartBrand !== brand) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { brand: brand } })
        });
      }

      sessionStorage.setItem(storageKey, brand);
    } catch (e) {
      // Silently fail — brand sync is non-critical
    } finally {
      syncing = false;
    }
  }

  await syncBrand();

  window.addEventListener('focus', syncBrand);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncBrand();
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncBrand();
  });
})();
